import { registerEnumType } from 'type-graphql'

export enum StatusEnum {
  Active = 'Active',
  InActive = 'InActive',
  Pending = 'Pending',
}

registerEnumType(StatusEnum, {
  name: 'StatusEnum',
  description: 'The basic status of entity',
})

export const Status = {
  Active: {
    value: StatusEnum.Active,
    description: 'The entity is active and available for use.',
    sort: 0,
    color: '#198754',
  },
  InActive: {
    value: StatusEnum.InActive,
    description: 'The entity is inactive and hidden from selections.',
    sort: 1,
    color: '#6c757d',
  },
  Pending: {
    value: StatusEnum.Pending,
    description: 'The entity is pending review or activation.',
    sort: 2,
    color: '#ffc107',
  },
}
